import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../EntityAccount.css';

import StateSynchronizer from '../../../../../utils/StateSynchronizer';
class FundGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.fundGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
      rowSelection: "multiple",
    };
  }

  getRowNodeId = data => {
    return data.fundId;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const COLUMNS_KEY = 'fund-list-grid-col-state';

    StateSynchronizer.syncGrid(params, this.state.columnDefs, COLUMNS_KEY);
  };

  render() {
    const {
      fundArray,
      className = 'grid-wrapper',
      loadFundListActionStatus,
    } = this.props;

    const isLoading = loadFundListActionStatus === ACTION_STATUS.LOGINING;
    if (loadFundListActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadFundListActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={fundArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default FundGrid;